module.exports = __webpack_public_path__ + "media/images/lp_twitter-d275090818e496eb727d6abb7bd18251.webp";